import axios from 'axios'
import { apiUrl, apiWeb } from '@/config/net'
import qs from 'qs'
const logateApi = 'https://logate.i200.cn'

/**
 * 代理商注册页面
 */
export default class AgentRegisterUser {
  /**
   * 获取验证码地址方法
   * @return {Promise<AxiosResponse | never>}
   */
  getCodeImgPath () {
    return axios.post(`${apiWeb}/albert/security/verify-code`).then(res => {
      return res.data
    })
  }

  /**
   * 获取注册的凭证 rid
   * @return {Promise<AxiosResponse | never>}
   */
  getCreateReg () {
    return axios.post(`${apiWeb}/albert/security/create_reg`).then(res => {
      return res.data
    })
  }

  /**
   * 检测当前手机号的状态
   * @param phoneNum
   * @return {Promise<AxiosResponse | never>}
   */
  checkUserStatus (phoneNum) {
    return axios.get(`${apiWeb}/albert/security/check-account?account=${phoneNum}`).then(res => {
      return res.data
    })
  }

  /**
   * 重新发送验证码
   * @param phoneNum
   * @return {Promise<AxiosResponse | never>}
   */
  resendCode (phoneNum) {
    let dataObj = qs.stringify({ account: phoneNum }) // 得到转换后的数据为 string 类型
    return axios({
      method: 'post',
      url: `${apiUrl}/Reg/ajax/action.ashx?type=resend`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: dataObj  // 直接提交转换后的数据即可
    }).then(res => {
      return res.data
    })
  }

  /**
   * 注册用户事件
   * @param params
   * params {account: 'xxxx',
   * password: 'xxx',
   * verifycode: 'xxx,
   * type: 1,
   * flag: 12,
   * recommend: 'xxx',
   * mobileweb: 'on',
   * regagentflag: 'xxx',
   * vid: 'xxxx',
   * rid: 'xxxxx
   * }
   */
  registerUser (params) {
    return axios.post(`${apiWeb}/albert/security/reg`, params).then(res => {
      return res.data
    })
  }

  /**
   * 验证用户的验证码
   * @param params {account: 'xxxx', verifycode: 'xxxxx'}
   * @return {Promise<AxiosResponse | never>}
   */
  verifyCode (params) {
    return axios.post(`${apiWeb}/albert/security/activiate`, params).then(res => {
      return res.data
    })
  }
  // 获取图片验证码
  getImgCode () {
    return axios.get(`${logateApi}/gatentry/apipub/reg/capcode`).then(res => {
      return res.data.data
    })
  }
  // 获取短信验证码
  getSmScode (params) {
    return axios.post(`${logateApi}/gatentry/apipub/reg/smscode`, params).then(res => {
      return res.data
    })
  }
  confirmReg (params) {
    return axios.post(`${logateApi}/gatentry/apipub/reg/unireg`, params).then(res => {
      return res.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/model/agent-register-user/index.js